module.exports = __webpack_public_path__ + "img/weitu.4352aa0b.png";